import type { User } from "../../types";
import { formatTime } from "../../functions";
import { SECONDARY_ATTRIBUTES_1, SECONDARY_ATTRIBUTES_2, SECONDARY_ATTRIBUTES_3 } from "../../constants";
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  Typography,
  CardHeader,
  TableContainer,
} from "@mui/material";

export default function SecondaryTables(props: { user: User }) {
  const { user } = props;

  return (
    <>
      {user.UserInfo.firstAuditUser ? (
        <Card sx={{ width: "100%" }}>
          <CardHeader
            title={
              <Typography variant="h6" component="h4">
                First audit
              </Typography>
            }
          />

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {SECONDARY_ATTRIBUTES_1.map((tableHeadProp) => (
                    <TableCell key={tableHeadProp.id} align="center">
                      <Typography sx={{ fontWeight: "bold" }}>{tableHeadProp.label}</Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {!user ? null : (
                  <TableRow>
                    <TableCell align="center">{user.UserInfo.firstAuditUser}</TableCell>

                    <TableCell align="center">{formatTime(user.UserInfo.firstAuditTime)}</TableCell>

                    <TableCell align="center">{user.UserInfo.firstAuditDecision}</TableCell>

                    <TableCell align="center">{user.UserInfo.firstAuditReason}</TableCell>

                    <TableCell align="center">{user.UserInfo.firstAuditComment}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      ) : null}

      {user.UserInfo.secondAuditUser ? (
        <Card sx={{ width: "100%" }}>
          <CardHeader
            title={
              <Typography variant="h6" component="h4">
                Second audit
              </Typography>
            }
          />

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {SECONDARY_ATTRIBUTES_2.map((tableHeadProp) => (
                    <TableCell key={tableHeadProp.id} align="center">
                      <Typography sx={{ fontWeight: "bold" }}>{tableHeadProp.label}</Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {!user ? null : (
                  <TableRow>
                    <TableCell align="center">{user.UserInfo.secondAuditUser}</TableCell>

                    <TableCell align="center">{formatTime(user.UserInfo.secondAuditTime)}</TableCell>

                    <TableCell align="center">{user.UserInfo.secondAuditDecision}</TableCell>

                    <TableCell align="center">{user.UserInfo.secondAuditReason}</TableCell>

                    <TableCell align="center">{user.UserInfo.secondAuditComment}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      ) : null}

      {user.UserInfo.thirdAuditUser ? (
        <Card sx={{ width: "100%" }}>
          <CardHeader
            title={
              <Typography variant="h6" component="h4">
                Third audit
              </Typography>
            }
          />

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {SECONDARY_ATTRIBUTES_3.map((tableHeadProp) => (
                    <TableCell key={tableHeadProp.id} align="center">
                      <Typography sx={{ fontWeight: "bold" }}>{tableHeadProp.label}</Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {!user ? null : (
                  <TableRow>
                    <TableCell align="center">{user.UserInfo.thirdAuditUser}</TableCell>

                    <TableCell align="center">{formatTime(user.UserInfo.thirdAuditTime)}</TableCell>

                    <TableCell align="center">{user.UserInfo.thirdAuditDecision}</TableCell>

                    <TableCell align="center">{user.UserInfo.thirdAuditReason}</TableCell>

                    <TableCell align="center">{user.UserInfo.thirdAuditComment}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      ) : null}
    </>
  );
}
